var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import styles from "./Footer.module.css";
var Footer = /** @class */ (function (_super) {
    __extends(Footer, _super);
    function Footer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Footer.prototype.render = function () {
        return (React.createElement("div", { className: styles.footer, style: this.props.style }, this.props.children));
    };
    Footer.LeftPart = FooterLeftPart;
    Footer.StepsCounterPart = FooterStepsCounterPart;
    Footer.RightPart = FooterRightPart;
    return Footer;
}(React.Component));
export { Footer };
export function FooterLeftPart(_a) {
    var children = _a.children;
    return React.createElement("div", { className: styles.footerLeftPart }, children);
}
export function FooterStepsCounterPart(_a) {
    var children = _a.children;
    return React.createElement("div", { className: styles.footerStepsCounterPart }, children);
}
export function FooterRightPart(_a) {
    var children = _a.children;
    return React.createElement("div", { className: styles.footerRightPart }, children);
}
